export const GAME_WIDTH = 960;
export const GAME_HEIGHT = 540;
export const WORLD_WIDTH = 8400;
export const GROUND_Y = 446;
export const GRAVITY_Y = 780;
export const LAUNCH_X = 126;
export const LAUNCH_Y = 374;
export const MAX_POWER = 960;
export const MIN_POWER = 360;
export const BEST_DISTANCE_KEY = 'squirrel-launcher-chaos-best-distance';
